import { FinanceType, MonthlyPrice, RulesEngineRuleResultType } from "@cf247/pricing";

export default function usePriceForTerm(prices: MonthlyPrice[], term: number, pcp = false) {
 
  prices = prices.filter(p => p.financeType === (pcp ? FinanceType.PCP : FinanceType.HP));

  if (!prices || !prices.length) {
    return null
  }

  if (!prices.filter(p => !p.failed).length) {
    const sorted = prices.sort((a, b) => b.term < a.term ? 1 : -1);
    const fil = sorted.filter(p => pcp ? p.isPcpSupported : null);
    const allReasons = fil.length ? fil.map(p => p.failReasons) : null;
    const allReasonsFlat = allReasons ? allReasons.reduce((acc, val) => acc.concat(val), []) : null;
    
    let sub = "";
    if(allReasonsFlat && allReasonsFlat.length){
      for(const reason of allReasonsFlat.filter(r => r.type === RulesEngineRuleResultType.Decline)){
        if(reason.message.includes("Vehicle age")) sub = "Vehicle age"
        else if(reason.message.includes("Mileage")) sub = "Vehicle mileage"
      }
      if(sub == ""){
        for(const reason of allReasonsFlat.filter(r => r.type === RulesEngineRuleResultType.Warning)){
          if(reason.message.includes("No residual")) sub = "No residual"
        }
      }
    }
    return { value: null, label: "Unavailable", subtext: sub == "" ? null : sub, term: term, obj: null }
  }

  const t = prices.find(i => i.term === term && !i.failed);

  if (t) {
    return { value: t.monthlyPayment, label: '-', subtext: `${pcp ? t.lenderName : ''}`, term: term, obj: t }
  }

  const next = prices.filter(p => !p.failed).sort((a, b) => a.term < b.term ? 1 : -1)[0];

  return next ? { value: next.monthlyPayment, label: "-1", subtext: `Max ${next.term} months`, term: next.term, obj: next } : null
}

